<section class="popup-page" aria-labelledby="access-assigned-title">
  <header>
    <span class="user-name">{{ userName }}</span>
    <h2>{{ 'PROFILE_POPUP_CONFIRM_ACCESS' | translate }}</h2>
  </header>

  <div class="content" role="status">
    <div class="success-icon" aria-hidden="true">
      <span>
        <svg viewBox="0 0 64 64"><path d="M18 33 L28 43 L47 22" /></svg>
      </span>
    </div>
    <h3 id="access-assigned-title">{{ 'PROFILE_POPUP_ACCESS_ASSIGNED_SUCCESS' | translate }}</h3>
    <p>{{ 'PROFILE_POPUP_PENDING_ACCESS_ASSIGNED_NOTICE' | translate }}</p>
  </div>

  <div class="actions">
    <button type="button" class="primary-button" (click)="viewProfile.emit()">{{ 'ADD_USER_VIEW_PROFILE' | translate }}</button>
    <button type="button" class="secondary-button" (click)="addAnotherUser.emit()">{{ 'ACCESS_COMPLETED_ADD_ANOTHER_USER' | translate }}</button>
  </div>
</section>
